import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../../shared/base-components/base.component';

export class SearchResultsModalData {
    constructor(public title: string, public results: any, public searchString: string, public context: number) {}
}

@Component({
    selector: 'search-results-modal',
    templateUrl: './search-results-modal.html'
})

export class SearchResultsModalComponent extends BaseComponent {
    public title: string;
    public results: any;
    public searchString: string;
    public dataLoaded: boolean;

    constructor(public dialogRef: MatDialogRef<SearchResultsModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: SearchResultsModalData) {
        super();
        this.title = data.title;
        this.results = data.results;
        this.searchString = data.searchString;
        this.dataLoaded = false;
    }

    ngOnInit() {
        this.dataLoaded = true;
    }

    cancel() {
        this.dialogRef.close();
    }

    itemSelected(item: any) {
        this.dialogRef.close(item);
    }
}
